import React from "react";
import { CandybarItemConfigType } from "./types";
import CandybarItemConfigs from "./CandybarItemConfigs";

interface Props {
    config: CandybarItemConfigType,
    onOptionSelect: Function,
    unitConfigs,
}

function CandybarSubConfigs(props:Props) {
    const { config, onOptionSelect, unitConfigs } = props;
    const unitConfig = unitConfigs && (config.id in unitConfigs) ? unitConfigs[config.id] : null;

    return config.options.map(option => {
        const selected = unitConfig && (unitConfig.indexOf(option.id) > -1);

        if (!selected || !option.subConfigs.length) {
            return null;
        }

        return <CandybarItemConfigs configs={option.subConfigs} isSubConfig unitConfig={unitConfigs} onOptionSelect={onOptionSelect} />
    });
}

export default CandybarSubConfigs;